<template>
<!-- 批量添加 -->
<ly-batch-input title="批量添加货品" example="编码
100100
编码,调账差额
100100,-560.00" ref="binput" @confirm="addProducts">
<template slot='statement'>
    <p>批量添加支持:1、按货品编码；2、按货品编码,调账差额；等方式进行添加。批量添加输入框内每一行代表添加一个货品(列用逗号隔开)，注意输入时不要带有空格或其他特殊字符以免添加失败。批量添加完成后请检查后提交单据。</p>
</template>
</ly-batch-input>
<!-- 批量添加end -->
</template>
<script>
// @time 2017-9-19 welpher 添加批量添加组件
import LyBatchInput from './main'
export default {
    props:{
        postUrl:String,
        type: {
            type: String,
            default: ''
        }, // 2017-10-20 
        warehouseId: {
            type: [Number, String],
            default: ''
        } // 2017-11-07 加入，需要仓库ID
    },
    components: {
        LyBatchInput
    },
    methods:{
        /**
         * 批量添回商器
         * @author welpher
         */
        addProducts (value) {
            // 根据换行进行分割
            let tempPro = value.split(/\n/g); 
            let products = [];                    
            for (let i = 0,len = tempPro.length; i < len; i++) {
                // 中文横线转为负号
                let str = tempPro[i].replace('－', '-')
                let obj = str.split(/[，|,]/g);
                // if (obj.length === 3 && obj[0] && obj[1] >= 0 && obj[2] >= 0.00) {
                //     products.push(obj);
                // } else {
                //     this.$alert('第 ' + (i + 1) + ' 行输入格式有误，请检查后重新输入！', '出错啦！', {
                //         confirmButtonText: '确定'
                //     });
                //     return;
                // }  
                // 
                /* 这里取消数量,价格也可有可无,也可为负数  @update 2017-10-20 by zjs  */
                if ((obj.length === 1 && obj[0]) || (obj.length === 2 && obj[0] && !isNaN(obj[1]))) {
                    products.push(obj);
                } else {
                    this.$alert('第 ' + (i + 1) + ' 行输入格式有误，请检查后重新输入！', '出错啦！', {
                        confirmButtonText: '确定'
                    });
                    return;
                }  
            }
            this.$api.create(this.postUrl,{
                    type: this.type, 
                    product:products,
                    warehouse_id: this.warehouseId
                }).then((rs) => {
                if (rs.undefine_product_codes.length > 0) {
                    let productCodes = rs.undefine_product_codes.join(",");
                    this.$alert('未找到对应货品(货品编号:' + productCodes + ');请确认后重新添加！', '出错啦！', {
                        confirmButtonText: '确定'
                    });
                }
                if (rs.product.length > 0) {
                    // vm.onChange(rs.product);
                    this.$emit('complete', rs.product);
                    this.$message({
                        message: '已添加！',
                        type: 'success'
                    });
                }
            }).catch((err) => {
                console.log('batchinput error:', err)
            });
        },
        /**
         * 打开批量添加商品
         * @author welpher
         * 
         */
        show () {
            this.$refs['binput'].open()
        }
    }
}
</script>
